import { Store } from "../redux/store";
import JobsService from "../services/JobsService";
import { setJobsQueue } from "../redux/actions";
import { applySmartMinutesJobWithVoice } from "../views/SmartMinutes/applySmartMinutesJob";

const fetchGradeJobQueue = async () => {
  try {
    const jobs = await JobsService.getJobQueue();
    Store.dispatch(setJobsQueue(jobs));
    (jobs || []).forEach(job => {
      if (job && job.name === "process_smart_minutes" && job.status === "success") {
        applySmartMinutesJobWithVoice(job);
      }
    });
  } catch (error) {
    console.error("Erro ao buscar fila de jobs:", error);
  }
};

export default fetchGradeJobQueue;
